import { DateTime } from 'luxon';
import type { GolfEventSummary } from '../types/api.types';
import SubNavLink from '../common/sub-nav-link';

interface TourEventNavigatorProps {
  tourEvents: GolfEventSummary[];
}

export default function TourEventNavigator({ tourEvents }: TourEventNavigatorProps) {
  const eventLinks = tourEvents.map((event) => (
    <SubNavLink
      key={event.id}
      to={`/summer-tour/${event.id}`}
      label={event.date ? DateTime.fromISO(event.date).year : ''}
    />
  ));
  return (
    <div className="sub-nav">
      <SubNavLink key="Overview" to="/summer-tour" label="Overview" end />
      {eventLinks}
    </div>
  );
}
